import { useEffect, useState } from 'react';
import { formatMarketResolutionCountdown } from '../lib/marketResolutionDisplay.ts';

const DEFAULT_POLL_MS = 60_000;

/**
 * Live-updating countdown from `resolution_time`. When `enabled` is false, still reflects
 * `resolution_time` but does not start an interval (e.g. settled markets).
 */
export function useResolutionCountdown(
  resolutionTime?: string | null,
  options?: { enabled?: boolean; pollMs?: number },
): string {
  const enabled = options?.enabled ?? true;
  const pollMs = options?.pollMs ?? DEFAULT_POLL_MS;

  const [text, setText] = useState(() => formatMarketResolutionCountdown(resolutionTime ?? null));

  useEffect(() => {
    setText(formatMarketResolutionCountdown(resolutionTime ?? null));
  }, [resolutionTime]);

  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => {
      setText(formatMarketResolutionCountdown(resolutionTime ?? null));
    }, pollMs);
    return () => window.clearInterval(id);
  }, [resolutionTime, enabled, pollMs]);

  return text;
}
